import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import {
  Component,
  DestroyRef,
  inject,
  signal,
  ViewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { RouterOutlet } from "@angular/router";

import { FooterComponent } from "./footer.component";
import { HeaderComponent } from "./header.component";
import { SidenavComponent } from "./sidenav.component";

@Component({
  selector: "admin-shell",
  standalone: true,
  imports: [
    RouterOutlet,
    MatSidenavModule,
    FooterComponent,
    HeaderComponent,
    SidenavComponent,
  ],
  template: `
    <mat-sidenav-container class="shell-container">
      <mat-sidenav
        #sidenav
        [mode]="isMobile() ? 'over' : 'side'"
        [opened]="!isMobile()"
        (openedChange)="sidenavOpened.set($event)"
        class="shell-sidenav"
      >
        <admin-sidenav (toggleSidenav)="sidenav.toggle()" />
      </mat-sidenav>

      <mat-sidenav-content>
        <admin-header
          [showNavToggle]="!sidenavOpened()"
          (toggleSidenav)="sidenav.toggle()"
        />
        <main class="shell-content">
          <router-outlet />
        </main>
        <admin-footer />
      </mat-sidenav-content>
    </mat-sidenav-container>
  `,
  styles: [
    `
      .shell-container {
        height: 100vh;
      }
      .shell-sidenav {
        width: 240px;
        border-right: 1px solid var(--admin-sidenav-border);
        border-top-right-radius: 0;
      }
      mat-sidenav-content {
        display: flex;
        flex-direction: column;
        min-height: 100%;
      }
      .shell-content {
        padding: 24px;
        flex: 1;
        min-height: 0;
      }
    `,
  ],
})
export class ShellComponent {
  @ViewChild("sidenav") sidenav!: MatSidenav;
  isMobile = signal(false);

  /** Mirrors the drawer's open state — hides the header hamburger while open. */
  sidenavOpened = signal(true);
  private destroyRef = inject(DestroyRef);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.isMobile.set(result.matches);
        // Seed the open state from the breakpoint: on a cold handset load the
        // drawer initializes closed via [opened] without emitting openedChange,
        // which would leave sidenavOpened stuck true and hide the header
        // hamburger — making the nav unreachable on phones.
        this.sidenavOpened.set(!result.matches);
        if (this.sidenav && result.matches) {
          this.sidenav.close();
        }
      });
  }
}
